module.exports = __webpack_public_path__ + "static/img/12.6650775.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/12.jpg
// module id = kvhG
// module chunks = 36